<template lang="pug">
UniversalLink(:link='link' class='group no-underline cursor-pointer')
  div(
    class='image-box bg-white border border-solid border-gray-light p-2 h-16 flex justify-center items-center flex-col md:h-24 group-hover:border-gray group-focus:border-gray'
  )
    slot(name='image')
      img(v-if='imageSrc' :src='imageSrc' :alt='text' class='h-full object-contain')
  div(v-if='text' class='text-gray-darkest text-sm text-center pt-1 group-hover:text-black group-focus:text-black') {{ text }}
</template>
<script>
export default defineNuxtComponent({
  props: {
    link: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
})
</script>
